/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SharedModule } from '@shared/shared.module';
import { ReminderDetailsComponent } from './reminder-details/reminder-details.component';
import { ReminderOverlayComponent } from './reminder-overlay/reminder-overlay.component';

@NgModule({
    declarations: [ReminderOverlayComponent, ReminderDetailsComponent],
    exports: [
        ReminderDetailsComponent
    ],
    imports: [
        SharedModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule
    ]
})
export class RemindersModule { }
